import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { InternalNavItem } from '@app/_models/internal-nav-item/internal-nav-item';

@Component({
    selector: 'app-internal-nav',
    templateUrl: `./internal-nav.component.html`,
    styleUrls: ['./internal-nav.component.scss'],
})
export class InternalNavComponent implements OnChanges {
    @Input() items: InternalNavItem[] = [];
    @Input() loadFirstUrl: boolean = true;
    @Output() openEdit: EventEmitter<InternalNavItem> = new EventEmitter<InternalNavItem>();
    @Output() updatedUrl: EventEmitter<any> = new EventEmitter<any>();
    @Output() updatedIframeTitles: EventEmitter<{ title: string; subtitle: string }> = new EventEmitter<{
        title: string;
        subtitle: string;
    }>();
    selectedUrl: string;

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.items?.currentValue && this.items?.length && this.loadFirstUrl) {
            this.changeUrl(this.items[0]);
        }
    }

    openEditDialog(item: InternalNavItem): void {
        this.openEdit.emit(item);
    }

    changeUrl(item: InternalNavItem): void {
        this.selectedUrl = item.url;
        this.updatedUrl.emit(item?.url);
        this.updatedIframeTitles.emit({ title: item?.iframeTitle ?? '', subtitle: item?.iframeSubtitle ?? '' });
    }
}
